import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Register',
        component: () => import('@/views/Register.vue')
    },
    {
        path: '/Register/:pin',
        name: 'Register',
        component: () => import('@/views/Register.vue')
    },
    {
        path: '/Instructions',
        name: 'Instructions',
        component: () => import('@/views/Instructions.vue')
    },
    {
        path: '/Questions/:number',
        name: 'Questions',
        component: () => import('@/views/Questions.vue'),
        props: true
    },
    {
        path: '/Annexes',
        name: 'Annexes',
        component: () => import('@/views/Annexes.vue')
    },
    {
        path: '/Result',
        name: 'Result',
        component: () => import('@/views/Result.vue'),
    },
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        console.log(to, from, savedPosition)
        return { x: 0, y: 0 }
    }

})

export default router
